import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import OrdersTable from '../../components/blocks/OrdersTable';

import {
  getDropshipOrders,
  getDropshipOrdersFilters,
  setDropshipOrdersOffset,
  setDropshipOrdersPerPage,
  setDropshipOrdersSearchById,
  setDropshipOrdersSort,
  setDropshipOrdersLoading,
} from '../../store/actions/dropshipOrders';

import { retailerGetOrder } from '../../store/actions/retailerOrders';

function DropshipOrdersContainer(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDropshipOrders());
    dispatch(getDropshipOrdersFilters());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <OrdersTable {...props} showSupplierColumn />;
}

const mapStateToProps = (state) => {
  const { data, isLoading, retailers, offset, search, perPage, count, sort, statusCount } = state.dropshipOrders;

  const { suppliersNames } = state.role;
  const { orderModal } = state.retailerOrders;

  return {
    data,
    isLoading,
    retailers,
    offset,
    search,
    perPage,
    count,
    sort,
    statusCount,
    orderModal,
    suppliersNames,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setOffset: (offset) => dispatch(setDropshipOrdersOffset(offset)),
  setPerPage: (perPage) => dispatch(setDropshipOrdersPerPage(perPage)),
  filterById: (count) => dispatch(setDropshipOrdersSearchById(count)),
  setSort: (field) => dispatch(setDropshipOrdersSort(field)),
  setDropshipOrdersLoading: (bool) => dispatch(setDropshipOrdersLoading(bool)),
  openOrderModal: (order) => dispatch(retailerGetOrder(order)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DropshipOrdersContainer);

DropshipOrdersContainer.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setDropshipOrdersLoading: PropTypes.func.isRequired,
  openOrderModal: PropTypes.func.isRequired,
  suppliersNames: PropTypes.object,
};
